import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=244cc1ca&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"
import style0 from "./Lists.vue?vue&type=style&index=0&id=244cc1ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244cc1ca",
  null
  
)

export default component.exports